import React from 'react'

import { useWrapperContext } from 'components/Wrapper/Wrapper'
import { Button } from 'shared/components'
import { PartnersForm } from './PartnersForm'

import { transformFormType } from 'shared/pipes'

import { FormTypes } from 'models'

import classes from './Partners.module.scss'

export const Partners = (): JSX.Element => {
  const { setFormOpened } = useWrapperContext()

  const renderBlocks = () => {
    const items = [
      {
        type: FormTypes.Inform,
        title: transformFormType(FormTypes.Inform),
        descr:
          'Сотрудничество в рамках\nкомплексного продвижения сериалов,\nфильмов и специальных проектов.',
        cls: classes.item_inform,
      },
      {
        type: FormTypes.Sponsor,
        title: transformFormType(FormTypes.Sponsor),
        descr: `Прямая реклама, спонсорская интеграция и\nпродакт-плейсмент в фильмах и сериалах.\n`,
        cls: classes.item_sponsor,
      },
    ]

    return items.map((item, itemIndex) => (
      <div key={itemIndex} className={`${classes.col} col-xs-12 col-sm-6`}>
        <div className={`${classes.item} ${item.cls}`}>
          <div className={classes.item_info}>
            <div className={classes.item_title}>{item.title}</div>
            <div className={classes.item_descr}>{item.descr}</div>
            <Button
              className={classes.item_btn}
              btnType="secondary_dark"
              size="medium"
              onClick={() => {
                setFormOpened(item.type)
              }}
            >
              Отправить заявку
            </Button>
          </div>
        </div>
      </div>
    ))
  }

  return (
    <div className={classes.container}>
      <div
        className="container reveal-from-bottom-medium"
        data-reveal-delay={30}
      >
        <h2>МЫ ОТКРЫТЫ НОВЫМ ПАРТНЕРСТВАМ</h2>

        <div className={`row mb-2 ${classes.row}`}>{renderBlocks()}</div>

        <PartnersForm />
      </div>
    </div>
  )
}
